import { Combo } from "../../../core/component"
import { FormEntryField, QueryPageableRequest, QueryPageableResponse } from "../../../core/type"
import { User } from "../../user/type"
import { useLazyQuery } from '@apollo/client'
import { UserFindRequest, UserRole } from '../../user/type/user-query'
import { GetUsers } from '../../user/graphql/user-queries.graphql'
import Enumerable from "linq"

export const AppraisalFormUser = ({ onChange, value, }: FormEntryField<number>) => {
  const [getUsers] = useLazyQuery<
    QueryPageableResponse<User, 'usersFind'>,
    QueryPageableRequest<UserFindRequest>>(GetUsers)

  return (
    <Combo<User, number>
      value={value}
      onChange={(value) => onChange!(value as number)}
      fetch={async ({ request, value, search }) => {

        const { data: valueData } = value
          ? await getUsers({
            variables: {
              request: {
                take: request?.take ?? 100,
                skip: request?.skip ?? 0,
                id: value,
              }
            }
          })
          : { data: { usersFind: { data: [], count: 0 } } } as { data: QueryPageableResponse<User, 'usersFind'> }

        const { data: searchData } = await getUsers({
          variables: {
            request: {
              take: request?.take ?? 100,
              skip: request?.skip ?? 0,
              name: search ?? '',
              role: {
                eq: UserRole.Appraiser,
              },
            }
          }
        })

        const list = Enumerable.from([
          ...valueData?.usersFind.data ?? [],
          ...searchData?.usersFind.data ?? [],
        ])
          .distinct(e => e.id)
          .toArray()

        return list.map((e) => ({
          value: e.id ?? 0,
          display: e.name,
          item: e ?? {},
        }))
      }}
    />
  )
}
